import { attributesTypes } from '../../components/become-a-host/attributesTypes';

// interface Attachment {
//   status: number;
//   description: null;
//   originalFileName: string;
//   attachmentType: number;
// }
export class PropertyInfoContextDto {
  attributeInfo: AttributeInfo[] = [];
  address: Address = new Address();
  medias: string[] = [];
  documents: any;
  currentStep: number = 1;
  id: number = 0;
  userCompleteName: string | undefined;
  userId: any;
  status: number = 0;
  hasIdentityCard: boolean = false;

  // constructor() {}
  constructor(anotherObject: PropertyInfoContextDto | null = null) {
    Object.assign(this, anotherObject);
    this.address = new Address(anotherObject?.address);
  }

  public getInfo(type: attributesTypes): string[] {
    if (this.attributeInfo.length == 0) return [];
    const temp = this.attributeInfo.find((x) => x.attribute.id == type);
    if (temp === undefined) return [];
    const result: string[] = [];

    if (temp.attribute.valueType === 20 || temp.attribute.valueType === 40 || temp.attribute.valueType === 50) {
      result.push(temp.attribute.value);
    } else {
      const keysSelected = Object.keys(temp.values).filter((key) => temp.values[Number(key)].isSelected);
      keysSelected.forEach((key) => {
        result.push(temp.values[Number(key)].label);
      });
    }

    return result;
  }
}

export class Address {
  address: string = '';
  addressFromMapbox?: string = '';

  constructor(anotherObject: Address | null = null) {
    Object.assign(this, anotherObject);
  }

  public isCompleteAddress(): boolean {
    const mapBoxObj = this.addressFromMapbox && JSON.parse(this.addressFromMapbox);
    if (!mapBoxObj) return false;

    return mapBoxObj.address !== undefined;
  }

  public getCity(): string {
    return this.getInternal('place.');
  }

  public getPostalCode(): string {
    return this.getInternal('postcode.');
  }

  // The neiborhood
  public getLocality(): string {
    return this.getInternal('locality.');
  }

  public getRegion(): string {
    return this.getInternal('region.');
  }

  public getCountry(): string {
    return this.getInternal('country.');
  }

  public getCoordinates(): [number, number] {
    const mapBoxObj = this.addressFromMapbox && JSON.parse(this.addressFromMapbox);
    if (!mapBoxObj) return [0, 0];
    return mapBoxObj.geometry.coordinates as [number, number];
  }

  public getLongitude(): number {
    const mapBoxObj = this.addressFromMapbox && JSON.parse(this.addressFromMapbox);
    if (!mapBoxObj) return 0;
    return mapBoxObj.geometry.coordinates[0];
  }

  public getLatitude(): number {
    const mapBoxObj = this.addressFromMapbox && JSON.parse(this.addressFromMapbox);
    if (!mapBoxObj) return 0;
    return mapBoxObj.geometry.coordinates[1];
  }

  private getInternal(toSearch: string): string {
    const mapBoxObj = this.addressFromMapbox && JSON.parse(this.addressFromMapbox);
    if (!mapBoxObj) return '';
    const results = mapBoxObj?.context.find((context: any) => {
      return context.id.includes(toSearch);
    });
    if (results && Object.keys(results).length) {
      return results.text;
    } else return results?.length > 0 ? results[0].text : '';
  }
}

export class AttributeInfo {
  attribute: Attribute = new Attribute();
  values: { [id: number]: Values } = {};
}

export class Attribute {
  id: number = 0;
  name: string = '';
  valueType: number = 0;
  value: string = '';
}

export class Values {
  label: string = '';
  isSelected: boolean = false;
}

export class DocumentTypeEnum {
  static readonly IdentityCard: number = 10;
  static readonly Passport: number = 20;
  static readonly DrivingLicense: number = 30;
  static readonly Cud: number = 40;
  static readonly PayCheck: number = 50;
  static readonly WorkContract: number = 60;
  static readonly EnergyCertificate: number = 1000;
  static readonly Planimetry: number = 1010;
  static readonly CadastralPlan: number = 1020;
  static readonly HouseContract: number = 1030;
}

export class EntityType {
  static readonly User: number = 10;
  static readonly Property: number = 20;
}
